import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import QRCode from "qrcode";
import { useCart } from "../context/CartContext";

export const useUpiPaymentQR = () => {
  const { getBookingServicesPayload, cart } = useCart();

  const [qrImage, setQrImage] = useState(null);
  const [paymentMeta, setPaymentMeta] = useState(null);
  const [loading, setLoading] = useState(false);
  const [paymentLink, setPaymentLink] = useState(null);
  const [error, setError] = useState(null);

  const buildUpiString = ({ upiId, name, amount }) => {
    return `upi://pay?pa=${upiId}&pn=${encodeURIComponent(
      name
    )}&am=${amount}&cu=INR`;
  };

  const generateQrFromAmount = async ({ upiId, label, amount }) => {
    const upiString = buildUpiString({
      upiId,
      name: label,
      amount,
    });

    const qr = await QRCode.toDataURL(upiString, {
      width: 220,
      margin: 2,
      errorCorrectionLevel: "M",
    });

    setPaymentLink(upiString);
    setQrImage(qr);

    return {
      upiString,
      qrImage: qr,
    };
  };

  const initCartBasedQR = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const servicesPayload = {
        services: getBookingServicesPayload(),
      };

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/service-bookings/price-preview`,
        servicesPayload
      );

      const { paymentQR, totalAmount } = res.data;

      await generateQrFromAmount({
        upiId: paymentQR.upiId,
        label: paymentQR.label,
        amount: totalAmount,
      });

      setPaymentMeta(res.data);
    } catch (err) {
      console.error("UPI QR init failed", err);
      setError("Failed to generate payment QR");
      setQrImage(null);
    } finally {
      setLoading(false);
    }
  }, [cart]);

  const initAmountOnlyQR = useCallback(async ({ amount }) => {
    try {
      setLoading(true);
      setError(null);

      // 1️ Fetch active QR from backend
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/payment-qr/get-active-qr`
      );

      const { upiId, label } = res.data.data;

      // 2️ Build UPI string
      const upiString = buildUpiString({
        upiId,
        name: label,
        amount,
      });

      // 3️ Generate QR locally
      const qr = await QRCode.toDataURL(upiString, {
        width: 220,
        margin: 2,
        errorCorrectionLevel: "M",
      });

      // 4️ Update state
      setPaymentLink(upiString);
      setQrImage(qr);
      setPaymentMeta({
        paymentQR: { upiId, label },
        totalAmount: amount,
      });
    } catch (err) {
      console.error("Active QR payment init failed", err);
      setError("Failed to generate payment QR");
      setQrImage(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    initCartBasedQR();
  }, [initCartBasedQR]);

  return {
    qrImage,
    paymentMeta,
    loading,
    error,
    paymentLink,

    // explicit handlers
    refreshQR: initCartBasedQR,
    initAmountOnlyQR,
  };
};

// import { useEffect, useState, useCallback } from "react";
// import axios from "axios";
// import QRCode from "qrcode";
// import { useCart } from "../context/CartContext";

// export const useUpiPaymentQR = () => {
//   const { getBookingServicesPayload, cart } = useCart();
//   const [qrImage, setQrImage] = useState(null);
//   const [paymentMeta, setPaymentMeta] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [paymentLink, setPaymentLink] = useState(null);
//   const [error, setError] = useState(null);

//   const buildUpiString = ({ upiId, name, amount }) => {
//     return `upi://pay?pa=${upiId}&pn=${encodeURIComponent(
//       name
//     )}&am=${amount}&cu=INR`;
//   };

//   const initPaymentQR = useCallback(async () => {
//     try {
//       setLoading(true);
//       setError(null);

//       const servicesPayload = {
//         services: getBookingServicesPayload(),
//       };
//       const res = await axios.post(
//         `${process.env.REACT_APP_API_URL}/service-bookings/price-preview`,
//         servicesPayload
//       );

//       const { paymentQR, totalAmount } = res.data;

//       const upiString = buildUpiString({
//         upiId: paymentQR?.upiId,
//         name: paymentQR?.label,
//         amount: totalAmount,
//       });
//       setPaymentLink(upiString);
//       const qr = await QRCode.toDataURL(upiString, {
//         width: 220,
//         margin: 2,
//         errorCorrectionLevel: "M",
//       });

//       setPaymentMeta(res.data);
//       setQrImage(qr);
//     } catch (err) {
//       console.error("UPI QR init failed", err);
//       setError("Failed to generate payment QR");
//       setQrImage(null);
//     } finally {
//       setLoading(false);
//     }
//   }, [cart]);

//   useEffect(() => {
//     initPaymentQR();
//   }, [initPaymentQR]);

//   return {
//     qrImage,
//     paymentMeta,
//     loading,
//     error,
//     paymentLink,
//     refreshQR: initPaymentQR,
//   };
// };
